module.exports = __webpack_public_path__ + "static/img/4519_phase_function_Paper_Points.93aaf07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4519_phase_function_Paper_Points.png
// module id = Rp5w
// module chunks = 0